//Angular References
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AngularFileUploaderComponent } from 'angular-file-uploader';

//Service
import { UtilityService } from '../../../services/shared/utility.service';
import { ContactService } from '../../../services/contact.service';
import { InventionService } from '../../../services/invention.service';
import { WizardService } from '../../../services/wizard.service';
import { CountryService } from '../../../services/country.service';
import { StateService } from '../../../services/state.service';
import { UserService } from '../../../services/user.service';
import { MediaImagesService } from '../../../services/mediaimages.service';
import { ContractSessionService } from '../../../services/contractsession.service';
import { NavigationService } from '../../../services/navigation.service';
import { InfoCollectService } from '../../../services/InfoCollect.service';
import { ContratActionLogService } from '../../../services/contratActionLog.service';
import { EmailService } from '../../../services/email.service';

//Models
import { User } from '../../../models/user.model';
import { ContactResponse, ContactDetails } from '../../../models/contact.model';
import { InventionResponse, InventionDetails } from '../../../models/invention.model';
import { BGInformInvention, BGInformInventionResponse } from '../../../models/bgInformInvention.model';
import { WizardResponse, WizardReadyResponse, WizardCurrentResponse, WizardDetails } from '../../../models/wizard.model';
import { Country } from '../../../models/country.model';
import { State } from '../../../models/state.model';
import { mediaImages, MediaDocImagesResponse, MediaImagesResponse, mediaDoc, ROIRefreshFlagResponse } from '../../../models/mediaImages.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { ContractSession, ContractSessionResponse } from '../../../models/contractsession.model';
import { Navigation, NavigationResponse, NavigationSteps, NavigationStepsResponse } from '../../../models/navigation.model';
import { EmailDetails, EmailResponse } from '../../../models/email.model';

//Custom Validators
import { CustomValidators } from '../../../shared/custom.validators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContractActionLog } from '../../../models/contractActionLog.model';
import { isNullOrUndefined } from 'util';
import { retry } from 'rxjs/operators';

//For jquery
declare var $: any;

@Component({
    selector: 'app-roi-document',
    templateUrl: './roi-document.component.html',
    styleUrls: ['./roi-document.component.css']
})
/** roi-document component*/
export class RoiDocumentComponent implements OnInit {
    private ROIFlagResponse: ROIRefreshFlagResponse;
    contractActionlog: ContractActionLog;
    @ViewChild('roiInventionMediaUploader') roiInventionMediaUploader: AngularFileUploaderComponent;
    @ViewChild('roiInventorMediaUploader') roiInventorMediaUploader: AngularFileUploaderComponent;
    todayDate = new FormControl(new Date());
    base64Str: string;
    panelTitle: string;
    saveButtonMsg: string = 'Save & Continue';
    currentStep: number = 12;
    step1: number = 12;
    step2: number = 13;
    step3: number = 14;
    step4: number = 15;
    isSaving: boolean = false;
    isLoading: boolean = false;
    otherInventor: boolean = false;
    roiDocumentForm: FormGroup;
    roiDocumentData: ContactResponse;
    chkInventor2: boolean = false;
    currentUser: User;
    private encryptedUser: string = '';
    private contactResponse: ContactResponse;
    private contactDetails: ContactDetails;
    private contractSession: ContractSession;
    private contractSessionResponse: ContractSessionResponse;
    private bgInformInvention: BGInformInvention;
    private bgInformInventionResponse: BGInformInventionResponse;
    private inventionResponse: InventionResponse;
    private inventionDetails: InventionDetails;
    private navigation: Navigation;
    private navigationResponse: NavigationResponse;
    private navigationSteps: NavigationSteps[];
    private navigationStepsResponse: NavigationStepsResponse;
    private wizardResponse: WizardResponse;
    private wizardReadyResponse: WizardReadyResponse;
    private wizardCurrentResponse: WizardCurrentResponse;
    private wizardDetails: WizardDetails;
    private mediaImages: mediaImages;
    private simpleResponse: SimpleResponse;
    private mediaImagesResponse: MediaImagesResponse;
    private mediaDocImagesResponse: MediaDocImagesResponse;
    private emailDetails: EmailDetails;
    private emailResponse: EmailResponse;
    stateList: State[];
    filteredStateList: State[];
    countryList: Country[];
    mediaImagesList: mediaImages[];
    inventorImagesList: mediaImages[];
    defaultCountryId: number = 1; //USA countryId
    private globalResponse: any;
    contactId: number;
    inventionId: number = 1;
    isInventorImage: boolean = true;
    wizard: WizardDetails;
    contactId2: number;
    c2Present: boolean;
    documentTypeId: number;
    documentTypeIds: number[] = [];
    wizardStepId: number;
    image_to_number: string = '';
    resetUpload: boolean;
    afuConfig: any;
    inventorConfig: any;
    site: string = '';
    key: string = '';
    isUserAuth: boolean = false;
    authMsg: string = '';
    contractSessionId: number = 0;
    clpUserId: number;
    lastAddedImageId: number = 0;
    refreshImageFlag: boolean;
    isRefreshCall: number = 0;
    isRefreshImageConfig: boolean;
    isROIEnable: boolean;
    emailTemplateType: string = "";
    phoneMask: string;
    maxLength: string;
    refreshInventorImage: any;
    isOtherCountry: boolean = false;
    zipLength: number = 10;
    chkStatus: boolean = false;
    isPatentPlusUser: boolean = false;
    companyName: string;
    inventionHistoryText: string;
    inventionUseText: string;
    inventionFulFillText: string;
    materialsUsedText: string;
    uniqueFeaturesText: string;

    /** roi-document ctor */
    constructor(private fb: FormBuilder,
        private _utilityService: UtilityService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _contactService: ContactService,
        private _inventionService: InventionService,
        private _wizardService: WizardService,
        private _stateService: StateService,
        private _countryService: CountryService,
        private _mediaImagesService: MediaImagesService,
        private _contractSessionService: ContractSessionService,
        private _navigationService: NavigationService,
        private _infoCollectService: InfoCollectService,
        private _contractActionLogService: ContratActionLogService,
        private _emailService: EmailService,
        private _snackBar: MatSnackBar,
    ) {

    }

    ngOnInit() {
        this.isLoading = true;
        this.loadroiDocument();
        this._route.paramMap.subscribe(async params => {
            if (params.has('invention')) {
                this.inventionId = +params.get('invention');
                if (params.has('patentId')) {
                    this.isPatentPlusUser = params.get('patentId') == "1" ? true : false;
                    //this.companyName = this.isPatentPlusUser ? "PatentPlus" : "InventHelp";
                    this.companyName = "InventHelp";
                }
            }
        });

        this.afuConfig = {
            theme: 'dragNDrop',
            hideResetBtn: false,
            hideSelectBtn: false,
            maxSize: 100,
            uploadAPI: {
                url: this.site + 'api/MediaImages/ImagePost/' + this.inventionId,
                headers: {
                },
            },
            formatsAllowed: '.jpg,.png,.pdf,.docx, .txt,.gif,.jpeg,.xlsx,.pptx,.bmp,.tiff,.mp4',
            multiple: true,
            replaceTexts: {
                selectFileBtn: 'Select Media',
                resetBtn: 'Reset',
                uploadBtn: 'Upload Media',
                dragNDropBox: 'Drag and Drop your image here',
                attachPinBtn: 'Attach Files...',
                afterUploadMsg_success: '',
                afterUploadMsg_error: 'Upload Failed!',
            }
        };
        this.inventorConfig = {
            theme: 'dragNDrop',
            hideResetBtn: false,
            hideSelectBtn: false,
            maxSize: 100,
            uploadAPI: {
                url: this.site + 'api/MediaImages/InventorMedia_Create/' + this.inventionId + '/' + this.isInventorImage,
                headers: {
                },
            },
            formatsAllowed: '.jpg,.png,.pdf,.docx, .txt,.gif,.jpeg,.xlsx,.pptx,.bmp,.tiff,.mp4',
            multiple: true,
            replaceTexts: {
                selectFileBtn: 'Select Media',
                resetBtn: 'Reset',
                uploadBtn: 'Upload Media',
                dragNDropBox: 'Drag and Drop your image here',
                attachPinBtn: 'Attach Files...',
                afterUploadMsg_success: '',
                afterUploadMsg_error: 'Upload Failed!',
            }
        };
        this.getROIRefreshFlags(this.inventionId, 0);
        this.fetchMediaImagesList(this.inventionId);
        this.fetchInventorImagesList(this.inventionId);
        this.refresh();
        this.patentPlusROIChanges();

        this._wizardService.getEvolveCSSiteURLAsync(this.encryptedUser)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.statusCode === 0) {
                        this.simpleResponse = UtilityService.clone(result);
                        if (this.simpleResponse) {
                            this.site = this.simpleResponse.messageString;
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });

    }

    updateContractLogObjectModel(Action: string) {
        switch (Action) {
            case "roiFormSubmit": //****
                this.contractActionlog.audiFlag = this.contractActionlog.dtROIForm || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                this.contractActionlog.actionFlag = "roiFormSubmit";
                break;
            case "roiDocSign": //****
                this.contractActionlog.audiFlag = this.contractActionlog.dtROIDoc || (this.contractActionlog.modifiedBy != null && this.contractActionlog.modifiedBy != this.clpUserId) ? true : false;
                this.contractActionlog.actionFlag = "roiDocSign";
                break;
            default:
        }
        this.contractActionlog.modifiedBy = this.clpUserId;
    }

    async saveContrActionAcitonLog() {
        await this._contractActionLogService.updateContractActionLog(this.encryptedUser, this.contractActionlog)
            .then(res => {
                if (res) {
                    this.contractActionlog = UtilityService.clone(res);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadContractActionlog(contractSessionId: number) {

        await this._contractActionLogService.getContractActionLog(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractActionlog = UtilityService.clone(res);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private getROIRefreshFlags(inventionId: number, isfreshCall: number): void {
        if (!isNullOrUndefined(inventionId) && !isNullOrUndefined(isfreshCall)) {
            this._mediaImagesService.getROIRefreshFlag(inventionId, isfreshCall, this.encryptedUser).pipe(retry(3))
                .subscribe(
                    (result: ROIRefreshFlagResponse) => {
                        this.ROIFlagResponse = result;
                    },
                    error => {
                    }
                );
        }
        else
            console.log("roi-document.component.getROIRefreshFlags:-" + "inventionId-" + inventionId + "isfreshCall-" + isfreshCall);
    }

    refresh() {
        //this.getROIRefreshFlags(this.inventionId, this.isRefreshCall); 


        this.refreshInventorImage = setTimeout(() => {
            this.isRefreshImageConfig = this.ROIFlagResponse && this.ROIFlagResponse.roiRefreshFlag ? this.ROIFlagResponse.roiRefreshFlag.isRefreshImage : false;
            if ((this.refreshImageFlag && this.isRefreshImageConfig) || this.ROIFlagResponse.roiRefreshFlag.inventionId == 0) {
                this.getROIRefreshFlags(this.inventionId, this.isRefreshCall);
                this.isRefreshCall = 1;
                this.fetchMediaImagesList(this.inventionId);
                this.fetchInventorImagesList(this.inventionId);
            }
            //else {
            //    this.getROIRefreshFlags(this.inventionId, this.isRefreshCall);
            //}
            this.refresh();
        }, 10000);
    }

    ngOnDestroy() {
        clearTimeout(this.refreshInventorImage);
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 5000,
        });
    }

    docUpload(env) {
        this.fetchCurruptedhMediaImages(this.inventionId);
        this.fetchMediaImagesList(this.inventionId);
    }

    inventorPhotoUpload(env) {
        this.fetchCurruptedhMediaImages(this.inventionId);
        this.fetchInventorImagesList(this.inventionId);
    }

    get form() { return this.roiDocumentForm.controls; }


    onSubmitROIPage(): void {
        this.validateCurrentStep("submit");
        this.updateContractLogObjectModel("roiFormSubmit");
        this.saveContrActionAcitonLog();
    }

    private async saveData(CurrentStep, action?: string, step?: string) {
        this._inventionService.getInventionAsync(this.encryptedUser, this.inventionId)
            .then(async (result: InventionResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.inventionResponse = UtilityService.clone(result);
                        if (this.inventionResponse) {
                            this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);
                            this.isROIEnable = this.inventionDetails.isROIEnable;
                            if (this.isROIEnable) {
                                if ($("#state option:selected").val() === '-1') {
                                    this.openSnackBar("Please select State.", "");
                                    return;
                                }
                                else {
                                    this.isSaving = true;
                                    this.copyFormValuesToDataObject(action);
                                    if (step == "nextStep") {
                                        if (this.currentStep == 15 && action == "submit") {
                                            this.currentStep = this.currentStep + 1;
                                            this.saveBGInformInvention(action);
                                        }
                                        else if (this.currentStep < this.step4 && action != 'saveDraft') {
                                            if (this.isPatentPlusUser) {
                                                if (this.currentStep == 14)
                                                    this.currentStep = this.chkStatus && action == "submit" ? this.currentStep + 2 : this.currentStep;
                                                else
                                                    this.currentStep = this.currentStep + 1;
                                            }
                                            else
                                                this.currentStep = this.currentStep + 1;
                                        }
                                        if (this.currentStep == 15) {
                                            this.saveBGInformInvention(action);
                                            this.panelTitle = 'Background Information About Invention';
                                            this.saveButtonMsg = 'Save';
                                        }
                                        else if (this.isPatentPlusUser && this.currentStep == 14) {
                                            this.saveButtonMsg = 'Save';
                                        }
                                        else {
                                            this.panelTitle = 'Record of Invention';
                                            this.saveButtonMsg = 'Save & Continue';
                                        }
                                    }
                                    if (this.contactId) {
                                        await this._contactService.updateContactAsync(this.encryptedUser, this.contactDetails)
                                            .then(res => {
                                                if (res) {
                                                    this.contactResponse = UtilityService.clone(res);
                                                    if (this.contactResponse) {
                                                        this._inventionService.updateInventionDetailsAsync(this.encryptedUser, this.inventionDetails)
                                                            .then(res => {
                                                                if (res) {
                                                                    this.inventionResponse = UtilityService.clone(res);
                                                                    this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);
                                                                    this.contactId2 = -1;
                                                                    this.c2Present = false;
                                                                    if (this.inventionDetails.I2CLPContactId) {
                                                                        this.contactId2 = this.inventionDetails.I2CLPContactId;
                                                                    }
                                                                    if (this.inventionDetails.Inventor2Present) {
                                                                        this.c2Present = this.inventionDetails.Inventor2Present;
                                                                    }
                                                                    if (this.inventionResponse && action == "submit") {
                                                                        this.saveNavigationWizard();
                                                                        if (this.currentStep == this.step4 + 1) {
                                                                            this.roiSubmissionEmail();
                                                                            this._router.navigate(['/thankyou', this.inventionId, this.contractSession.productId], {
                                                                                queryParamsHandling: "preserve"
                                                                            });
                                                                        }
                                                                    }
                                                                    this.openSnackBar("Details saved successfully.", "");
                                                                }
                                                            }).catch((err: HttpErrorResponse) => {
                                                                this._utilityService.handleErrorResponse(err);
                                                            });
                                                    }
                                                }
                                            }).catch((err: HttpErrorResponse) => {
                                                this._utilityService.handleErrorResponse(err);
                                            });
                                    }
                                }
                            }
                            else {
                                this.openSnackBar("This Contract is no longer exist in the system! Please contact Sales Representative.", "");
                            }
                        }
                    } else {
                        console.log("invention result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveBGInformInvention(action?: string) {

        this.copyFormValuesToDataObject(action);
        this._infoCollectService.BGInformInvention_CreateAsync(this.encryptedUser, this.bgInformInventionResponse)
            .then(res => {
                if (res) {
                    this.bgInformInventionResponse = UtilityService.clone(res);

                    if (this.bgInformInventionResponse) {
                        this.bgInformInvention = this.bgInformInventionResponse.bgInformInvention;
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadroiDocument() {
        this.roiDocumentForm = this.prepareroiDocumentForm();
        this.roiDocumentForm.reset();

        //Load the form controls
        this._route.queryParamMap.subscribe(params => {

            this._route.paramMap.subscribe(async params => {
                if (params.has('contact')) {
                    //Edit an existing office setup
                    this.contactId = +params.get('contact');

                    if (params.has('invention')) {
                        //Edit an existing office setup
                        this.inventionId = +params.get('invention');

                        if (params.has('clpUserId')) {
                            //Edit an existing office setup
                            this.clpUserId = +params.get('clpUserId');

                            if (params.has('contractSessionId')) {
                                //Edit an existing office setup
                                this.contractSessionId = +params.get('contractSessionId');
                                await this.loadContractSession();
                                this.loadContractActionlog(this.contractSessionId);
                                await this._wizardService.getTextToNumberAsync(this.encryptedUser, "ImageToNumber")
                                    .then(async (result: SimpleResponse) => {
                                        if (result) {
                                            if (result.statusCode == 0) {

                                                this.simpleResponse = UtilityService.clone(result);
                                                if (this.simpleResponse) {
                                                    this.image_to_number = UtilityService.clone(this.simpleResponse.messageString);
                                                }

                                            } else {
                                                console.log("result.statuscode: " + result.statusCode);
                                            }
                                        }
                                    })
                                    .catch((err: HttpErrorResponse) => {
                                        this._utilityService.handleErrorResponse(err);
                                    });
                                await this._contactService.getContactAsync(this.encryptedUser, this.contactId)
                                    .then(async (result: ContactResponse) => {
                                        if (result) {
                                            if (result.statusCode == 0) {

                                                this.contactResponse = UtilityService.clone(result);
                                                if (this.contactResponse) {
                                                    this.contactDetails = UtilityService.clone(this.contactResponse.contactDetails);
                                                    //if ((this.contactDetails.country.toLowerCase().startsWith("can")) || (this.contactDetails.country == "2")) {
                                                    //    this.contactDetails.country = "2";
                                                    //    this.defaultCountryId = 2;
                                                    //}
                                                    //else {
                                                    //    this.contactDetails.country = "1";
                                                    //    this.defaultCountryId = 1;
                                                    //}
                                                    //if (isNullOrUndefined(this.contractSession)) {
                                                    if ((this.contactDetails.country.toLowerCase() == "united kingdom") || (this.contactDetails.country.toLowerCase() == "uk")
                                                        || (this.contactDetails.country.toLowerCase() == "england") || (this.contactDetails.country.toLowerCase() == "great britain") || (this.contactDetails.country == "4")) {
                                                        this.contactDetails.country = "4";
                                                        this.defaultCountryId = 4;
                                                    }
                                                    else if ((this.contactDetails.country.toLowerCase() == "ireland") || (this.contactDetails.country.toLowerCase() == "ire") || (this.contactDetails.country == "6")) {
                                                        this.contactDetails.country = "6";
                                                        this.defaultCountryId = 6;
                                                    }
                                                    else if ((this.contactDetails.country.toLowerCase() == "aus") || (this.contactDetails.country.toLowerCase() == "australia") || (this.contactDetails.country == "3")) {
                                                        this.contactDetails.country = "3";
                                                        this.defaultCountryId = 3;
                                                    }
                                                    else if ((this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2")) {
                                                        this.contactDetails.country = "2";
                                                        this.defaultCountryId = 2;
                                                    }
                                                    else if ((this.contactDetails.country.toLowerCase() == "united states of america") || (this.contactDetails.country.toLowerCase() == "usa")
                                                        || (this.contactDetails.country.toLowerCase() == "us") || (this.contactDetails.country.toLowerCase() == "united states") || (this.contactDetails.country.toLowerCase() == "america")
                                                        || (this.contactDetails.country == "1") || (this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country))) {
                                                        this.contactDetails.country = "1";
                                                        this.defaultCountryId = 1;
                                                    }
                                                    else {
                                                        //this.contactDetails.country = "1";
                                                        this.defaultCountryId = 399;
                                                    }
                                                    //}
                                                    //else
                                                    //this.defaultCountryId = this.contractSession.CountryID;

                                                    await this.fetchCountryList();
                                                    await this.fetchStateList();
                                                    this.currentUser = UtilityService.clone(this.contactResponse.currentUser);
                                                }
                                                await this._inventionService.getInventionAsync(this.encryptedUser, this.inventionId)
                                                    .then(async (result: InventionResponse) => {
                                                        if (result) {
                                                            if (result.statusCode == 0) {
                                                                this.inventionResponse = UtilityService.clone(result);
                                                                if (this.inventionResponse) {
                                                                    this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);
                                                                    this.isROIEnable = this.inventionDetails.isROIEnable;
                                                                    //this.loadContractSession();
                                                                    this.loadNavigationWizard();
                                                                    this.loadBGInformation();
                                                                }
                                                                this.copyDataObjectToFormValues();
                                                            } else {
                                                                console.log("invention result status code: " + result.statusCode);
                                                            }
                                                        }
                                                    })
                                                    .catch((err: HttpErrorResponse) => {
                                                        this._utilityService.handleErrorResponse(err);
                                                    });
                                            } else {
                                                console.log("contact result status code: " + result.statusCode);
                                            }
                                        }
                                    })
                                    .catch((err: HttpErrorResponse) => {
                                        this._utilityService.handleErrorResponse(err);
                                    });


                                this.isLoading = false;
                            }
                            else
                                console.log("no contractSession");
                        }
                        else
                            console.log("no clpuser");
                    }
                    else
                        console.log("no invention");
                }
                else
                    console.log("no contact");
            });
        });

        this.panelTitle = 'Record of Invention';
    }

    validateCurrentStep(action?: string) {
        if (this.currentStep == 13 && this.isPatentPlusUser && action != 'saveDraft') {
            this.validateFormStep();
            this.saveData(this.currentStep, action, "nextStep");
            this.currentStep = this.currentStep + 1;
            this.saveButtonMsg = 'Save';
        }
        else if (this.currentStep == 14 && action != 'saveDraft' && !this.isPatentPlusUser) {
            if (this.validateFormStep()) {
                this.saveData(this.currentStep, action, "nextStep");
            }
            else {
                if (action != 'saveDraft' && !this.isPatentPlusUser) {
                    this.currentStep = this.currentStep + 1;
                    this.saveButtonMsg = 'Save';
                }
            }
        }
        else
            this.saveData(this.currentStep, action, "nextStep");
    }

    private async loadContractSession() {
        await this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractSession = UtilityService.clone(res);
                    this.contractSessionId = this.contractSession.ContractSessionId;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadBGInformation() {
        await this._infoCollectService.BGInformInvention_GetAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(async (result: BGInformInventionResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.bgInformInventionResponse = UtilityService.clone(result);
                        if (this.bgInformInventionResponse) {
                            this.bgInformInvention = UtilityService.clone(this.bgInformInventionResponse.bgInformInvention);
                            this.copyDataObjectToFormValues();
                        }
                    } else {
                        console.log("BGInformInvention result status code: " + result.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            })
    }


    private async loadNavigationWizard() {
        await this._navigationService.getNavigationWizardAsync(this.encryptedUser, this.inventionId, this.contractSessionId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.navigationResponse = UtilityService.clone(res);
                        if (this.navigationResponse) {
                            this.navigation = this.navigationResponse.navigation;
                        }
                    } else {
                        console.log("Navigation Wizard result status code: " + res.statusCode);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async saveNavigationWizard() {
        if (this.navigationResponse.navigation.inventionId > 0) {
            this._navigationService.createNavigationWizardAsync(this.encryptedUser, this.navigationResponse)
                .then(res => {
                    if (res) {
                        this.navigationResponse = UtilityService.clone(res);
                        if (this.navigationResponse) {
                        }
                    }
                }).catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    validateUserPhone() {
        let regPhone: number;
        let authPhone: number;
        this.authMsg = "";
        if (this.contactDetails) {
            authPhone = this.roiDocumentForm.controls.userPhone.value;
            let validPhoneNumer = this.contactDetails.mobile.replace('-', '');
            regPhone = parseInt(validPhoneNumer.substr(validPhoneNumer.length - 4));

            if (authPhone == null) {
                this.authMsg = "Please enter your vaild phone last 4 digits before submit.";
                return;
            }
            if (authPhone == regPhone) {
                this._inventionService.getInventionAsync(this.encryptedUser, this.inventionId)
                    .then(async (result: InventionResponse) => {
                        if (result) {
                            if (result.statusCode == 0) {
                                this.inventionResponse = UtilityService.clone(result);
                                if (this.inventionResponse) {
                                    this.inventionDetails = UtilityService.clone(this.inventionResponse.inventionDetails);
                                    this.isROIEnable = this.inventionDetails.isROIEnable;
                                    if (this.isROIEnable) {
                                        this.isUserAuth = true;
                                    }
                                    else {
                                        this.isUserAuth = false;
                                        this.openSnackBar("This ROI link is expired or has already been used. Please contact Sales Representative.", "");
                                    }
                                }
                            } else {
                                console.log("invention result status code: " + result.statusCode);
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            else {
                this.isUserAuth = false;
                this.authMsg = "Authentication Failed! Please enter your vaild phone last 4 digits."
            }
        }
    }

    validateFormStep(): boolean {
        this.chkStatus = false;

        this.roiDocumentForm.controls.firstname.markAsTouched();
        this.roiDocumentForm.controls.lastname.markAsTouched();
        this.roiDocumentForm.controls.address1.markAsTouched();
        this.roiDocumentForm.controls.country.markAsTouched();
        this.roiDocumentForm.controls.otherCountry.markAsTouched();
        this.roiDocumentForm.controls.state.markAsTouched();
        this.roiDocumentForm.controls.otherState.markAsTouched();
        this.roiDocumentForm.controls.city.markAsTouched();
        this.roiDocumentForm.controls.zipcode.markAsTouched();
        this.roiDocumentForm.controls.homephone;
        this.roiDocumentForm.controls.mobile;
        this.roiDocumentForm.controls.email.markAsTouched();
        this.roiDocumentForm.controls.age.markAsTouched();
        this.roiDocumentForm.controls.occupation.markAsTouched();
        if (!this.isPatentPlusUser) {
            this.roiDocumentForm.controls.salutation.markAsTouched();
            this.roiDocumentForm.controls.inventionadvantage.markAsTouched();
            this.roiDocumentForm.controls.possibleVariations.markAsTouched();
            this.roiDocumentForm.controls.specificGroups.markAsTouched();
        }
        this.roiDocumentForm.controls.inventname.markAsTouched();
        this.roiDocumentForm.controls.inventionhistory.markAsTouched();
        this.roiDocumentForm.controls.inventionuse.markAsTouched();
        if (this.roiDocumentForm.controls.hasmedia.value)
            this.roiDocumentForm.controls.hasmediaassist.markAsTouched();
        if (this.roiDocumentForm.controls.isOriginalInventor.value == false)
            this.roiDocumentForm.controls.isoriginalinventornoexplain.markAsTouched();
        this.roiDocumentForm.controls.inventionFulFill.markAsTouched();
        this.roiDocumentForm.controls.materialsUsed.markAsTouched();
        this.roiDocumentForm.controls.uniqueFeatures.markAsTouched();
        if (this.roiDocumentForm.controls.isNewProductNo.value == true)
            this.roiDocumentForm.controls.explainModification.markAsTouched();
        this.roiDocumentForm.controls.competitiveProducts.markAsTouched();

        this.roiDocumentForm.controls.firstname.updateValueAndValidity();
        this.roiDocumentForm.controls.lastname.updateValueAndValidity();
        this.roiDocumentForm.controls.address1.updateValueAndValidity();
        this.roiDocumentForm.controls.country.updateValueAndValidity();
        this.roiDocumentForm.controls.otherCountry.updateValueAndValidity();
        this.roiDocumentForm.controls.state.updateValueAndValidity();
        this.roiDocumentForm.controls.otherState.updateValueAndValidity();
        this.roiDocumentForm.controls.city.updateValueAndValidity();
        this.roiDocumentForm.controls.zipcode.updateValueAndValidity();
        this.roiDocumentForm.controls.homephone.updateValueAndValidity();
        this.roiDocumentForm.controls.mobile.updateValueAndValidity();
        this.roiDocumentForm.controls.email.updateValueAndValidity();
        this.roiDocumentForm.controls.age.updateValueAndValidity();
        this.roiDocumentForm.controls.occupation.updateValueAndValidity();
        if (!this.isPatentPlusUser) {
            this.roiDocumentForm.controls.salutation.updateValueAndValidity();
            this.roiDocumentForm.controls.inventionadvantage.updateValueAndValidity();
            this.roiDocumentForm.controls.possibleVariations.updateValueAndValidity();
            this.roiDocumentForm.controls.specificGroups.updateValueAndValidity();
        }
        this.roiDocumentForm.controls.inventname.updateValueAndValidity();
        this.roiDocumentForm.controls.hasmediaassist.updateValueAndValidity();
        this.roiDocumentForm.controls.inventionhistory.updateValueAndValidity();
        this.roiDocumentForm.controls.inventionuse.updateValueAndValidity();
        if (this.roiDocumentForm.controls.hasmedia.value)
            this.roiDocumentForm.controls.hasmediaassist.updateValueAndValidity();
        if (this.roiDocumentForm.controls.isOriginalInventor.value == false)
            this.roiDocumentForm.controls.isoriginalinventornoexplain.updateValueAndValidity();
        this.roiDocumentForm.controls.inventionFulFill.updateValueAndValidity();
        this.roiDocumentForm.controls.materialsUsed.updateValueAndValidity();
        this.roiDocumentForm.controls.uniqueFeatures.updateValueAndValidity();
        if (this.roiDocumentForm.controls.isNewProductNo.value == true)
            this.roiDocumentForm.controls.explainModification.updateValueAndValidity();
        this.roiDocumentForm.controls.competitiveProducts.updateValueAndValidity();

        if (this.roiDocumentForm.controls.firstname.status == "VALID" &&
            this.roiDocumentForm.controls.lastname.status == "VALID" &&
            this.roiDocumentForm.controls.address1.status == "VALID" &&
            this.roiDocumentForm.controls.country.status == "VALID" &&
            this.roiDocumentForm.controls.state.status == "VALID" &&
            this.roiDocumentForm.controls.city.status == "VALID" &&
            this.roiDocumentForm.controls.zipcode.status == "VALID" &&
            this.roiDocumentForm.controls.homephone.status == "VALID" &&
            this.roiDocumentForm.controls.mobile.status == "VALID" &&
            this.roiDocumentForm.controls.email.status == "VALID" &&
            this.roiDocumentForm.controls.age.status == "VALID" &&
            this.roiDocumentForm.controls.occupation.status == "VALID" &&
            this.roiDocumentForm.controls.otherCountry.status == "VALID" &&
            this.roiDocumentForm.controls.otherState.status == "VALID" &&
            this.roiDocumentForm.controls.inventname.status == "VALID" &&
            this.roiDocumentForm.controls.inventionhistory.status == "VALID" &&
            this.roiDocumentForm.controls.inventionuse.status == "VALID" &&
            this.roiDocumentForm.controls.inventionFulFill.status == "VALID" &&
            this.roiDocumentForm.controls.materialsUsed.status == "VALID" &&
            this.roiDocumentForm.controls.uniqueFeatures.status == "VALID" &&
            this.roiDocumentForm.controls.competitiveProducts.status == "VALID") {
            this.chkStatus = true;
        }

        if (!this.isPatentPlusUser && (
            this.roiDocumentForm.controls.salutation.status == "INVALID" || this.roiDocumentForm.controls.inventionadvantage.status == "INVALID" ||
            this.roiDocumentForm.controls.possibleVariations.status == "INVALID" || this.roiDocumentForm.controls.specificGroups.status == "INVALID")) {
            this.chkStatus = false;
        }

        if (this.roiDocumentForm.controls.hasmedia.value &&
            this.roiDocumentForm.controls.hasmediaassist.status == "INVALID") {
            this.chkStatus = false;
        }

        if (this.roiDocumentForm.controls.isOriginalInventor.value == false &&
            this.roiDocumentForm.controls.isoriginalinventornoexplain.status == "INVALID") {
            this.chkStatus = false;
        }

        if (this.roiDocumentForm.controls.isNewProductNo.value == true &&
            this.roiDocumentForm.controls.explainModification.status == "INVALID") {
            this.chkStatus = false;
        }

        if (this.chkStatus) {
            if (this.navigationResponse.navigation) {
                this.navigationResponse.navigation.isROIForm = true;
                this.inventionResponse.inventionDetails.IsAgree = true;
                this.navigationResponse.navigation.isROIDoc = true;
            }
        }

        return this.chkStatus;
    }

    setInfoCollecControl(name: any, Isenable: boolean): void {
        let ctrl = this.roiDocumentForm.controls[name];
        Isenable ? ctrl.enable() : ctrl.disable();
    }

    chkMarriedYesChange(e) {
        this.roiDocumentForm.patchValue({
            isMarriedNo: !e.target.checked,
            marriageYear: '',
        });
        this.setInfoCollecControl('marriageYear', e.target.checked);
    }

    chkMarriedNoChange(e) {
        this.roiDocumentForm.patchValue({
            isMarriedYes: !e.target.checked,
            marriageYear: '',
        });
        this.setInfoCollecControl('marriageYear', !e.target.checked);
    }

    chkChildrenYesChange(e) {
        this.roiDocumentForm.patchValue({
            isChildrenNo: !e.target.checked,
            childrenName: '',
        });
        this.setInfoCollecControl('childrenName', e.target.checked);
    }

    chkChildrenNoChange(e) {
        this.roiDocumentForm.patchValue({
            isChildrenYes: !e.target.checked,
            childrenName: '',
        });
        this.setInfoCollecControl('childrenName', !e.target.checked);
    }

    chkProductYesChange(e) {
        this.roiDocumentForm.patchValue({
            isNewProductNo: !e.target.checked,
            explainModification: '',
        });
        this.setInfoCollecControl('explainModification', !e.target.checked);
    }

    chkProductNoChange(e) {
        this.roiDocumentForm.patchValue({
            isNewProductYes: !e.target.checked,
            explainModification: '',
        });
        this.setInfoCollecControl('explainModification', e.target.checked);
    }

    changeSalutation(e: string) {
        this.roiDocumentForm.patchValue({
            salutation: e,
        });
    }

    validatePreviousStep() {
        this.saveData(this.currentStep);
        this.currentStep = this.currentStep - 1;
        if (this.currentStep == 15) {
            this.panelTitle = 'Background Information About Invention';
            this.saveButtonMsg = 'Save';
        }
        else {
            this.panelTitle = 'Record of Invention';
            this.saveButtonMsg = 'Save & Continue';
        }
    }

    validateDropdown(e) {
        const controlName = e.srcElement.id;
        this.roiDocumentForm.get(controlName).updateValueAndValidity();
    }

    private fetchMediaImagesList(inventionId): void {
        // Full reload: always request the complete list (lastAdded = 0) and assign it
        // directly in the next handler. The previous incremental-merge logic (driven by
        // the shared lastAddedImageId and built in the complete callback) could both
        // filter out a just-uploaded image and reset the list to [] on an empty poll,
        // which is why uploaded files showed in Azure but no thumbnail rendered.
        this._mediaImagesService.getMediaImageList(inventionId, 0, this.encryptedUser)
            .subscribe(
                (result: MediaImagesResponse) => {
                    this.mediaImagesResponse = result;
                    this.lastAddedImageId = result.lastAdded;
                    this.refreshImageFlag = true;
                    this.mediaImagesList = Array.isArray(result.listImages) ? Object.assign([], result.listImages) : [];
                    if (this.roiInventionMediaUploader)
                        this.roiInventionMediaUploader.resetFileUpload();
                },
                error => {
                    console.error(error);
                    this.mediaImagesList = null;
                }
            );
    }

    private fetchCurruptedhMediaImages(inventionId): void {

        this._mediaImagesService.getCurruptedMediaImageList(inventionId, this.encryptedUser)
            .subscribe(
                (result: MediaImagesResponse) => {
                    this.mediaImagesResponse = result;
                    if (!isNullOrUndefined(this.mediaImagesResponse.listImages)) {
                        this.openSnackBar("File/s (" + this.mediaImagesResponse.listImages[0].FileName + ") is/are corrupted. Please upload again!", "");
                    }
                    else
                        this.openSnackBar("Successfully Uploaded!", "");
                });
    }

    private fetchInventorImagesList(inventionId): void {
        // Full reload (see fetchMediaImagesList): request the complete inventor-photo
        // list and assign it in the next handler so a just-uploaded photo always renders
        // and a subsequent empty poll can never wipe the displayed list.
        this._mediaImagesService.getInventorImageList(inventionId, 0, this.encryptedUser)
            .subscribe(
                (result: MediaImagesResponse) => {
                    this.mediaImagesResponse = result;
                    this.lastAddedImageId = result.lastAdded;
                    this.refreshImageFlag = true;
                    this.inventorImagesList = Array.isArray(result.listImages) ? Object.assign([], result.listImages) : [];
                    if (this.roiInventorMediaUploader)
                        this.roiInventorMediaUploader.resetFileUpload();
                },
                error => {
                    console.error(error);
                    this.inventorImagesList = null;
                }
            );
    }

    private fetchCountryList(): void {
        this._countryService.getCountryList(this.encryptedUser)
            .subscribe(
                (result: Country[]) => {
                    this.globalResponse = result;
                },
                error => {
                    console.error(error);
                },
                () => {
                    if (Array.isArray(this.globalResponse)) {
                        this.countryList = Object.assign([], this.globalResponse.filter(x => x.id != 399));
                        this.globalResponse = null;
                    }
                }
            );
    }

    changeCountry(e) {
        this.handleChangeCountry(+e);
    }

    private async handleChangeCountry(countryId: number) {
        this.isOtherCountry = false;
        let maxSize: number = 10;
        if (countryId == 1 || countryId == 2) {
            maxSize = 10;
            this.phoneMask = '(000) 000-0000';
            this.maxLength = '14';
            this.roiDocumentForm.controls.otherState.clearValidators();
            this.roiDocumentForm.controls.homephone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
            this.roiDocumentForm.controls.workphone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
            this.roiDocumentForm.controls.mobile.setValidators([Validators.required, Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
            await this.roiDocumentForm.patchValue({
                homephone: this.contactDetails.homephone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                workphone: this.contactDetails.workphone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                mobile: this.contactDetails.mobile.replace(/[() -]/g, '').substring(0, maxSize) || ''
            });
        }
        else {
            maxSize = 50;
            this.phoneMask = '';
            this.maxLength = '50';
            this.roiDocumentForm.controls.homephone.clearValidators();
            this.roiDocumentForm.controls.workphone.clearValidators();
            this.roiDocumentForm.controls.mobile.setValidators([Validators.required]);
            if (countryId == 399) {
                this.isOtherCountry = true;
                this.roiDocumentForm.controls.state.clearValidators();
                this.roiDocumentForm.controls.otherState.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
            }
            else {
                this.isOtherCountry = false;
                this.roiDocumentForm.controls.otherState.clearValidators();
            }
            await this.roiDocumentForm.patchValue({
                homephone: this.contactDetails.homephone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                workphone: this.contactDetails.workphone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                mobile: this.contactDetails.mobile.replace(/[() -]/g, '').substring(0, maxSize) || ''
            });
            switch (countryId) {
                case 3: await this.roiDocumentForm.patchValue({ state: 'AUS' }); break;
                case 4: await this.roiDocumentForm.patchValue({ state: 'UK' }); break;
                case 6: await this.roiDocumentForm.patchValue({ state: 'IRE' }); break;
                case 399: await this.roiDocumentForm.patchValue({ state: '-1' }); break;
                default: break;
            }
        }
        await this.filterStateList(countryId).then(async res => {
            this.filteredStateList = res;
        });

    }

    getState(state: string, country: string) {
        let stateCode: string = '-1';
        if ((state == "United Kingdom") || (state == "UK") || (country == "4") || state.toLowerCase().startsWith("uk"))
            stateCode = "UK";
        else if ((state == "Ireland") || (state == "IRE") || (country == "6") || state.toLowerCase().startsWith("ire"))
            stateCode = "IRE";
        else if (state.toLowerCase().startsWith("aus") || (state == "AUS") || (country == "3"))
            stateCode = "AUS";
        else if ((this.contactDetails.country.toLowerCase() == "united states of america") || (this.contactDetails.country.toLowerCase() == "usa")
            || (this.contactDetails.country.toLowerCase() == "us") || (this.contactDetails.country.toLowerCase() == "united states") || (this.contactDetails.country.toLowerCase() == "america")
            || (this.contactDetails.country == "1") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))
            || (this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2"))
            stateCode = isNullOrUndefined(this.filteredStateList) ? "-1" : this.filteredStateList.filter(x => x.code.toLowerCase() == state.toLowerCase())[0].code;
        else
            stateCode = state;
        return stateCode;
    }

    private async fetchStateList() {
        await this._stateService.getStateList(this.encryptedUser)
            .then(async (result: State[]) => {
                this.stateList = UtilityService.clone(result);
                await this.handleChangeCountry(this.defaultCountryId);
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async filterStateList(iCountryId: number): Promise<State[]> {
        const filteredRecords: State[] = this.stateList.filter(st => st.countryId == iCountryId);
        return await UtilityService.clone(filteredRecords);
    }

    deleteInventionMedia(mediaID: number) {
        this._mediaImagesService.DeleteInventionMediaByID(mediaID, this.inventionId, this.encryptedUser)
            .subscribe(
                (result: MediaImagesResponse) => {
                    this.globalResponse = result;
                    this.mediaImagesResponse = result;
                },
                error => {
                    console.error(error);
                    this.mediaImagesList = null;
                },
                () => {

                    if (typeof this.globalResponse === 'object' && this.globalResponse.lastAdded > 0) {
                        let objMedia = this.mediaImagesList.find(x => x.MediaId == mediaID);
                        if (objMedia) {
                            objMedia.MediaId = -1;
                            this.mediaImagesList = this.mediaImagesList.filter(x => x.MediaId != -1);
                        }
                        this.globalResponse = null;
                    }
                    else
                        this.mediaImagesList = null;
                    this.openSnackBar("Media deleted successfully.", "");
                }
            );
    };

    deleteInventorMedia(mediaID: number) {
        this._mediaImagesService.DeleteInventionMediaByID(mediaID, this.inventionId, this.encryptedUser)
            .subscribe(
                (result: MediaImagesResponse) => {
                    this.globalResponse = result;
                    this.mediaImagesResponse = result;
                },
                error => {
                    console.error(error);
                    this.inventorImagesList = null;
                },
                () => {

                    if (typeof this.globalResponse === 'object' && this.globalResponse.lastAdded > 0) {
                        let objMedia = this.inventorImagesList.find(x => x.MediaId == mediaID);
                        if (objMedia) {
                            objMedia.MediaId = -1;
                            this.inventorImagesList = this.inventorImagesList.filter(x => x.MediaId != -1);
                        }
                        this.globalResponse = null;
                    }
                    else
                        this.inventorImagesList = null;
                    this.openSnackBar("Media deleted successfully.", "");
                }
            );
    };

    private prepareroiDocumentForm(): FormGroup {
        return this.fb.group({
            /*Contact Details Starts*/
            firstname: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            lastname: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],
            address1: [{ value: '' }, [Validators.required]],
            address2: [{ value: '' }],
            address3: [{ value: '' }],
            country: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            state: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            city: [{ value: '' }, [Validators.required]],
            zipcode: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9-\s]{0,50})$/)]],
            homephone: [{ value: '' }],
            workphone: [{ value: '' }],
            mobile: [{ value: '' }, [Validators.required]],
            email: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            salutation: [{ value: '-1' }, [CustomValidators.requiredDropdown(-1)]],
            otherCountry: [{ value: '' }],
            otherState: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]],

            /*Contact Details Ends*/

            /*Invention Details Starts*/
            inventname: [{ value: '' }, Validators.required],
            age: [{ value: '' }, [Validators.required, Validators.pattern(/^[0-9]{0,3}$/)]],
            occupation: [{ value: '' }, [Validators.required]],
            bcm_home: [{ value: false }],
            bcm_Cell: [{ value: false }],
            bcm_Email: [{ value: false }],
            isOriginalInventor: [{ value: true }],
            hasprototype: [{ value: false }],
            hasmedia: [{ value: false }],
            isagree: [{ value: false }],
            todayDate: [{ value: '' }, [Validators.required]],
            hasmediaassist: [{ value: '' }, [Validators.required]],
            inventionhistory: [{ value: '' }, [Validators.required]],
            inventionadvantage: [{ value: '' }, [Validators.required]],
            inventionuse: [{ value: '' }, [Validators.required]],
            //inventiondescription: [{ value: '' }, [Validators.required]],
            isoriginalinventornoexplain: [{ value: '' }, [Validators.required]],
            inventionFulFill: [{ value: '' }, [Validators.required]],
            weights: [{ value: '' }],
            lengths: [{ value: '' }],
            width: [{ value: '' }],
            shape: [{ value: '' }],
            materialsUsed: [{ value: '' }],
            uniqueFeatures: [{ value: '' }, [Validators.required]],
            isNewProductYes: [{ value: true }],
            isNewProductNo: [{ value: false }],
            explainModification: [{ value: '' }, [Validators.required]],
            possibleVariations: [{ value: '' }, [Validators.required]],
            competitiveProducts: [{ value: '' }, [Validators.required]],
            specificGroups: [{ value: '' }, [Validators.required]],
            /*Invention Details Ends*/

            /*Background Information About Invention  Starts*/
            otherFieldWorked: [{ value: '' }],
            educationalTraining: [{ value: '' }],
            inventionTime: [{ value: '' }],
            extraActivity: [{ value: '' }],
            isMarried: [{ value: false }],
            isMarriedYes: [{ value: false }],
            isMarriedNo: [{ value: false }],
            isChildren: [{ value: false }],
            isChildrenYes: [{ value: false }],
            isChildrenNo: [{ value: false }],
            marriageYear: [{ value: 0 }],
            spouseName: [{ value: '' }],
            childrenName: [{ value: '' }],
            residentDetails: [{ value: '' }],
            liveLocation: [{ value: '' }],
            culturalAffiliation: [{ value: '' }],
            inventionBenifits: [{ value: '' }],
            isSignApproved: [{ value: false }],
            /*Background Information About Invention Ends*/

            /*User Authentication Starts*/
            userPhone: [{ value: '' }, [Validators.required, Validators.pattern(/^[0-9]{0,4}$/)]],
            /*User Authentication Starts*/

        });
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched();
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    roiOnchange() {
        this.roiDocumentForm.patchValue({
            address1: this.roiDocumentForm.controls.address1.value.trim() || '',
            address2: this.roiDocumentForm.controls.address2.value.trim() || '',
            address3: this.roiDocumentForm.controls.address3.value.trim() || '',
            city: this.roiDocumentForm.controls.city.value.trim() || ''
        });
    }

    private copyDataObjectToFormValues() {
        let maxSize: number = 10;
        this.zipLength = 10;
        this.isOtherCountry = false;
        if (!isNullOrUndefined(this.contactDetails)) {
            if ((this.contactDetails.country.toLowerCase() == "united states of america") || (this.contactDetails.country.toLowerCase() == "usa")
                || (this.contactDetails.country.toLowerCase() == "us") || (this.contactDetails.country.toLowerCase() == "united states") || (this.contactDetails.country.toLowerCase() == "america")
                || (this.contactDetails.country == "1") || (this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country))
                || (this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2")) {
                this.contactDetails.country = ((this.contactDetails.country.toLowerCase() == "can") || (this.contactDetails.country.toLowerCase() == "canada") || (this.contactDetails.country == "2")) ? "2" : "1";
                this.phoneMask = '(000) 000-0000';
                this.maxLength = '14';
                this.roiDocumentForm.controls.otherState.clearValidators();
                setTimeout(() => {
                    this.roiDocumentForm.controls.homephone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
                    this.roiDocumentForm.controls.workphone.setValidators([Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
                    this.roiDocumentForm.controls.mobile.setValidators([Validators.required, Validators.pattern(/^\+?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/)]);
                });
            }
            else {
                switch (this.contactDetails.country.toLowerCase()) {
                    case "united kingdom": case "uk": case "england": case "great britain": this.contactDetails.country = "4"; break;
                    case "ireland": case "ire": this.contactDetails.country = "6"; break;
                    case "australia": case "aus": this.contactDetails.country = "3"; break;
                    default: break;
                }
                maxSize = 50;
                this.phoneMask = '';
                this.maxLength = '50';
                this.roiDocumentForm.controls.homephone.clearValidators();
                this.roiDocumentForm.controls.workphone.clearValidators();
                this.roiDocumentForm.controls.mobile.setValidators([Validators.required]);
                if (this.contractSession.CountryID == 399) {
                    this.isOtherCountry = true;
                    this.zipLength = 50;
                    this.roiDocumentForm.controls.otherState.setValidators([Validators.required, Validators.pattern(/^([a-zA-Z0-9.,-/&\s]{0,100})$/)]);
                    this.roiDocumentForm.controls.country.clearValidators();
                    this.roiDocumentForm.controls.state.clearValidators();
                }
                else {
                    this.isOtherCountry = false;
                    this.roiDocumentForm.controls.otherState.clearValidators();
                }
            }

            this.roiDocumentForm.patchValue({
                /*Contact Details Starts*/
                firstname: this.contactDetails.firstname || '',
                lastname: this.contactDetails.lastname || '',
                address1: this.contactDetails.address1 || '',
                address2: this.contactDetails.address2 || '',
                address3: this.contactDetails.address3 || '',
                country: this.isOtherCountry ? '-1' : this.contactDetails.country || '1',
                state: this.isOtherCountry ? '-1' : this.getState(this.contactDetails.state, this.contactDetails.country),
                city: this.contactDetails.city || '',
                zipcode: this.contactDetails.zipcode || '',
                homephone: this.contactDetails.homephone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                workphone: this.contactDetails.workphone.replace(/[() -]/g, '').substring(0, maxSize) || '',
                mobile: this.contactDetails.mobile.replace(/[() -]/g, '').substring(0, maxSize) || '',
                email: this.contactDetails.email || '',
                otherCountry: this.isOtherCountry ? this.contactDetails.country === "4" ? "United Kingdom" : this.contactDetails.country === "3" ? "Australia" : this.contactDetails.country === "6" ? "Ireland" : this.contactDetails.country === '2' ? "Canada" : this.contactDetails.country === "1" ? "USA" : this.contactDetails.country : '',
                otherState: this.isOtherCountry ? this.contactDetails.state : '',
                /*Contact Details Ends*/

                /*Invention Details Starts*/
                age: this.inventionDetails.Age || '',
                occupation: this.inventionDetails.Occupation || '',
                inventname: this.inventionDetails.InventionName || '',
                bcm_home: this.inventionDetails.BCM_Home,
                bcm_Cell: this.inventionDetails.BCM_Cell,
                bcm_Email: this.inventionDetails.BCM_Email,
                isOriginalInventor: this.inventionDetails.IsOriginalInventor || true,
                hasprototype: this.inventionDetails.HasPrototype,
                hasmedia: this.inventionDetails.HasMedia,
                isagree: this.inventionDetails.IsAgree || false,
                hasmediaassist: this.inventionDetails.HasMediaAssist || '',
                inventionhistory: this.inventionDetails.InventionHistory || '',
                inventionadvantage: this.inventionDetails.InventionAdvantage || '',
                inventionuse: this.inventionDetails.InventionUse || '',
                //inventiondescription: this.inventionDetails.InventionDescription || '',
                isoriginalinventornoexplain: this.inventionDetails.IsOriginalInventorNoExplain || '',
                inventionFulFill: this.inventionDetails.InventionFulFill || '',
                weights: this.inventionDetails.Weights || '',
                lengths: this.inventionDetails.Lengths || '',
                width: this.inventionDetails.Width || '',
                shape: this.inventionDetails.Shape || '',
                materialsUsed: this.inventionDetails.MaterialsUsed || '',
                uniqueFeatures: this.inventionDetails.UniqueFeatures || '',
                isNewProductYes: this.inventionDetails.IsNewProduct == true ? true : false,
                isNewProductNo: this.inventionDetails.IsNewProduct == true ? false : true,
                explainModification: this.inventionDetails.ExplainModification || '',
                possibleVariations: this.inventionDetails.PossibleVariations || '',
                competitiveProducts: this.inventionDetails.CompetitiveProducts || '',
                specificGroups: this.inventionDetails.SpecificGroups || '',
                /*Invention Details Ends*/
            });

            if (!isNullOrUndefined(this.contactDetails.salutation) && this.contactDetails.salutation != '') {
                this.roiDocumentForm.patchValue({
                    salutation: this.contactDetails.salutation.toLowerCase().startsWith('mrs') ? '2' :
                        this.contactDetails.salutation.toLowerCase().startsWith('mr') ? '1' :
                            this.contactDetails.salutation.toLowerCase().startsWith('ms') ? '3' :
                                this.contactDetails.salutation.toLowerCase().startsWith('miss') ? '4' : '-1',
                });
            }
            else {
                this.roiDocumentForm.patchValue({
                    salutation: '-1'
                });
            }
            if (this.bgInformInvention) {

                this.roiDocumentForm.patchValue({
                    /*Background Information About Invention  Starts*/
                    otherFieldWorked: this.bgInformInvention.otherFieldWorked || '',
                    educationalTraining: this.bgInformInvention.educationalTraining || '',
                    inventionTime: this.bgInformInvention.inventionTime || '',
                    extraActivity: this.bgInformInvention.extraActivity || '',
                    isMarried: this.bgInformInvention.isMarried || false,
                    isMarriedYes: this.bgInformInvention.isMarried ? true : false,
                    isMarriedNo: this.bgInformInvention.isMarried ? false : true,
                    marriageYear: this.bgInformInvention.marriageYear || '',
                    spouseName: this.bgInformInvention.spouseName || '',
                    isChildren: this.bgInformInvention.isChildren || false,
                    isChildrenYes: this.bgInformInvention.isChildren ? true : false,
                    isChildrenNo: this.bgInformInvention.isChildren ? false : true,
                    childrenName: this.bgInformInvention.childrenName || '',
                    residentDetails: this.bgInformInvention.residentDetails || '',
                    liveLocation: this.bgInformInvention.resiCommunity || '',
                    culturalAffiliation: this.bgInformInvention.culturalAffiliation || '',
                    inventionBenifits: this.bgInformInvention.inventionBenifits || '',
                    isSignApproved: this.bgInformInvention.isSignApproved || false,
                    /*Background Information About Invention Ends*/
                });
                this.setInfoCollecControl('marriageYear', this.bgInformInvention.isMarried);
                this.setInfoCollecControl('childrenName', this.bgInformInvention.isChildren);
            }
        }

    }

    private copyFormValuesToDataObject(action?: string) {
        /*Contact Details Starts*/
        this.contactDetails.firstname = this.roiDocumentForm.controls.firstname.value;
        this.contactDetails.lastname = this.roiDocumentForm.controls.lastname.value;
        this.contactDetails.address1 = this.roiDocumentForm.controls.address1.value;
        this.contactDetails.address2 = this.roiDocumentForm.controls.address2.value;
        this.contactDetails.address3 = this.roiDocumentForm.controls.address3.value;
        this.contactDetails.country = this.roiDocumentForm.controls.country.value === "4" ? "United Kingdom" : this.roiDocumentForm.controls.country.value === "3" ? "Australia" : this.roiDocumentForm.controls.country.value === "6" ? "Ireland" : this.roiDocumentForm.controls.country.value === "2" ? "Canada" : this.roiDocumentForm.controls.country.value === "1" ? "USA" : this.roiDocumentForm.controls.otherCountry.value;
        this.contactDetails.state = this.roiDocumentForm.controls.otherState.value === "" ? this.roiDocumentForm.controls.state.value : this.roiDocumentForm.controls.otherState.value;
        this.contactDetails.city = this.roiDocumentForm.controls.city.value;
        this.contactDetails.zipcode = this.roiDocumentForm.controls.zipcode.value;
        if ((this.contactDetails.country == "USA") || (this.contactDetails.country == "Canada") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) {
            if (this.roiDocumentForm.controls.homephone.value.trim() != "")
                this.contactDetails.homephone = this.roiDocumentForm.controls.homephone.value.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.homephone = this.roiDocumentForm.controls.homephone.value;
        }
        else
            this.contactDetails.homephone = this.roiDocumentForm.controls.homephone.value;
        if ((this.contactDetails.country == "USA") || (this.contactDetails.country == "Canada") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) {
            if (this.roiDocumentForm.controls.workphone.value.trim() != "")
                this.contactDetails.workphone = this.roiDocumentForm.controls.workphone.value.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.workphone = this.roiDocumentForm.controls.workphone.value;
        }
        else
            this.contactDetails.workphone = this.roiDocumentForm.controls.workphone.value;
        if ((this.contactDetails.country == "USA") || (this.contactDetails.country == "Canada") || ((this.contactDetails.country.trim() == "") || (isNullOrUndefined(this.contactDetails.country)))) {
            if (this.roiDocumentForm.controls.mobile.value.trim() != "")
                this.contactDetails.mobile = this.roiDocumentForm.controls.mobile.value.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
            else
                this.contactDetails.mobile = this.roiDocumentForm.controls.mobile.value;
        }
        else
            this.contactDetails.mobile = this.roiDocumentForm.controls.mobile.value;
        this.contactDetails.email = this.roiDocumentForm.controls.email.value;
        this.contactDetails.salutation = this.roiDocumentForm.controls.salutation.value == "1" ?
            'Mr.' : this.roiDocumentForm.controls.salutation.value == "2" ? 'Mrs.' :
                this.roiDocumentForm.controls.salutation.value == "3" ? 'Ms.' : 'Miss.';
        this.contactDetails.editOrigin = "ROI";
        /*Contact Details Ends*/

        /*Invention Details Starts*/
        this.inventionDetails.InventionId = this.inventionId;
        this.inventionDetails.InventionName = this.roiDocumentForm.controls.inventname.value;

        if (this.roiDocumentForm.controls.age.value > 120)
            this.inventionDetails.Age = 120;
        else

            this.inventionDetails.Age = this.roiDocumentForm.controls.age.value;
        this.inventionDetails.Occupation = this.roiDocumentForm.controls.occupation.value;
        this.inventionDetails.BCM_Home = this.roiDocumentForm.controls.bcm_home.value;
        this.inventionDetails.BCM_Cell = this.roiDocumentForm.controls.bcm_Cell.value;
        this.inventionDetails.BCM_Email = this.roiDocumentForm.controls.bcm_Email.value;
        this.inventionDetails.IsOriginalInventor = this.roiDocumentForm.controls.isOriginalInventor.value;
        this.inventionDetails.HasPrototype = this.roiDocumentForm.controls.hasprototype.value;
        this.inventionDetails.HasMedia = this.roiDocumentForm.controls.hasmedia.value;
        this.inventionDetails.HasMediaAssist = this.roiDocumentForm.controls.hasmediaassist.value;
        this.inventionDetails.InventionHistory = this.roiDocumentForm.controls.inventionhistory.value;
        this.inventionDetails.InventionAdvantage = this.roiDocumentForm.controls.inventionadvantage.value;
        this.inventionDetails.InventionUse = this.roiDocumentForm.controls.inventionuse.value;
        //this.inventionDetails.InventionDescription = this.roiDocumentForm.controls.inventiondescription.value;
        this.inventionDetails.IsOriginalInventorNoExplain = this.roiDocumentForm.controls.isoriginalinventornoexplain.value;
        this.inventionDetails.IsAgree = this.roiDocumentForm.controls.isagree.value;
        this.inventionDetails.isROIEnable = this.roiDocumentForm.controls.isagree.value == true && action == "submit" ? false : true;
        this.inventionDetails.InventionFulFill = this.roiDocumentForm.controls.inventionFulFill.value;
        this.inventionDetails.Weights = this.roiDocumentForm.controls.weights.value;
        this.inventionDetails.Lengths = this.roiDocumentForm.controls.lengths.value;
        this.inventionDetails.Width = this.roiDocumentForm.controls.width.value;
        this.inventionDetails.Shape = this.roiDocumentForm.controls.shape.value;
        this.inventionDetails.MaterialsUsed = this.roiDocumentForm.controls.materialsUsed.value;
        this.inventionDetails.UniqueFeatures = this.roiDocumentForm.controls.uniqueFeatures.value;
        if (this.roiDocumentForm.controls.isNewProductYes.value == true)
            this.inventionDetails.IsNewProduct = true;
        else
            this.inventionDetails.IsNewProduct = false;
        this.inventionDetails.ExplainModification = this.roiDocumentForm.controls.explainModification.value;
        this.inventionDetails.PossibleVariations = this.roiDocumentForm.controls.possibleVariations.value;
        this.inventionDetails.CompetitiveProducts = this.roiDocumentForm.controls.competitiveProducts.value;
        this.inventionDetails.SpecificGroups = this.roiDocumentForm.controls.specificGroups.value;
        /*Invention Details Ends*/


        /*Backgoung Information about Invention Starts*/
        if (this.bgInformInventionResponse.bgInformInvention) {
            this.bgInformInventionResponse.bgInformInvention.inventionId = this.inventionId;
            if (this.contractSession) {
                this.bgInformInventionResponse.bgInformInvention.productId = this.contractSession.productId;
                this.bgInformInventionResponse.bgInformInvention.clpUserId = this.contractSession.CLPUserId;
            }
            this.bgInformInventionResponse.bgInformInvention.contractSessionId = this.contractSessionId;
            this.bgInformInventionResponse.bgInformInvention.occupation = this.roiDocumentForm.controls.occupation.value;
            this.bgInformInventionResponse.bgInformInvention.otherFieldWorked = this.roiDocumentForm.controls.otherFieldWorked.value;
            this.bgInformInventionResponse.bgInformInvention.educationalTraining = this.roiDocumentForm.controls.educationalTraining.value;
            this.bgInformInventionResponse.bgInformInvention.inventionTime = this.roiDocumentForm.controls.inventionTime.value;
            this.bgInformInventionResponse.bgInformInvention.extraActivity = this.roiDocumentForm.controls.extraActivity.value;
            this.bgInformInventionResponse.bgInformInvention.age = + this.roiDocumentForm.controls.age.value;

            if (this.roiDocumentForm.controls.isMarriedYes.value || !this.roiDocumentForm.controls.isMarriedNo.value)
                this.bgInformInventionResponse.bgInformInvention.isMarried = true;
            else
                this.bgInformInventionResponse.bgInformInvention.isMarried = false;

            this.bgInformInventionResponse.bgInformInvention.marriageYear = this.roiDocumentForm.controls.marriageYear.value;
            this.bgInformInventionResponse.bgInformInvention.spouseName = this.roiDocumentForm.controls.spouseName.value;

            if (this.roiDocumentForm.controls.isChildrenYes.value == true || !this.roiDocumentForm.controls.isChildrenNo.value)
                this.bgInformInventionResponse.bgInformInvention.isChildren = true;
            else
                this.bgInformInventionResponse.bgInformInvention.isChildren = false;

            this.bgInformInventionResponse.bgInformInvention.childrenName = this.roiDocumentForm.controls.childrenName.value;
            this.bgInformInventionResponse.bgInformInvention.residentDetails = this.roiDocumentForm.controls.residentDetails.value;
            this.bgInformInventionResponse.bgInformInvention.resiCommunity = this.roiDocumentForm.controls.liveLocation.value;
            this.bgInformInventionResponse.bgInformInvention.culturalAffiliation = this.roiDocumentForm.controls.culturalAffiliation.value;
            this.bgInformInventionResponse.bgInformInvention.inventionBenifits = this.roiDocumentForm.controls.inventionBenifits.value;

        }
        /*Backgoung Information about Invention Ends*/
    }

    async roiSubmissionEmail() {
        this.setEmailDetails();
        if (this.setEmailDetails) {
            await this._emailService.sndEmailAsync(this.encryptedUser, this.emailDetails, this.contactId, this.emailTemplateType, this.contractSessionId)
                .then(res => {
                    if (res) {
                        if (res.statusCode == 0) {
                            this.emailResponse = UtilityService.clone(res);
                        } else {
                            console.log("Email send result status code: " + res.statusCode);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }
    setEmailDetails() {
        let email: EmailDetails = {
            from: "",
            message: "",
            subject: "",
            toList: "",
        }
        this.emailDetails = email;

        this.emailDetails.from = "";
        this.emailDetails.toList = "";
        this.emailDetails.message = "We are writing to let you know that ROI has been submitted by "
            + this.contactDetails.firstname + " for " + this.inventionDetails.InventionName;
        //this.emailDetails.subject = this.isPatentPlusUser ? "PatentPlus: ROI Submission" : "InventHelp: ROI Submission";
        this.emailDetails.subject = "InventHelp: ROI Submission";
        this.emailTemplateType = "ROISubmission";
    }

    patentPlusROIChanges() {
        if (this.isPatentPlusUser) {
            this.inventionHistoryText = "What problem does your invention solve?";
            this.inventionUseText = "What does your invention look like?";
            this.inventionFulFillText = "What makes your invention unique compared to similar inventions or products?";
            this.materialsUsedText = "5. What materials are required to build or create your invention?";
            this.uniqueFeaturesText = "Explain in detail how your invention functions?";
        }
        else {
            this.inventionHistoryText = "Describe the idea and what it actually does:";
            this.inventionUseText = "How is your invention used?";
            this.inventionFulFillText = "What need does this invention Fulfill? (What problem does it solve?)";
            this.materialsUsedText = "5. Materials used to make ideas:";
            this.uniqueFeaturesText = "What features do you believe your idea has that makes it unique and appealing? What do you think others will like most about your invention?";
        }
    }

    allowNumeric(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (key != 8 && key != 0 && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }
}
